<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <excuse-create-or-update v-model="excuse" :types="types"></excuse-create-or-update>
            <template #modal-footer><v-executer :loading="saving" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <div class="row px-1 pt-1">
            <div class="col-auto">
                <button class="btn btn-primary" v-on:click="createNew">Yeni İzin</button>
            </div>
            <div class="col-md-4 col-sm-6">
                <v-date-picker v-model="date" placeholder="Tarih Seçiniz"></v-date-picker>
            </div>
        </div>
        <div class="bg-light m-1 p-1 rounded row align-items-center">
            <div class="col-auto pr-1">
                <span class="material-icons-round today-icon d-block text-secondary">today</span>
            </div>
            <div class="col">
                <h1><strong>{{currentDay}}</strong></h1>
                <h3 class="mb-0">{{currentDayName}}</h3>
            </div>
        </div>
        <div>
            {{ personelExcuses }}
        </div>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import ExcuseCreateOrUpdate from '@/views/employee-operations/excuse/components/ExcuseCreateOrUpdate.vue'
import moment from 'moment'
export default {
    components:{
        BCard,
        ExcuseCreateOrUpdate
    },
    data() {
        return {
            date:moment().locale('tr').format('YYYY-MM-DD'),
            personelExcuses:[],
            saving:false,
            editing:false,
            types:[],
            excuse:{
                Id:null,
                EmployeeId:null,
                ExcuseTypeId:null,
                RequestDate:null,
                StartDateTime:null,
                EndDateTime:null,
                Description:null,
                Approved:null,
                Document:null,
            }
        }
    },
    mounted(){
        this.getPersonelExcuse()
    },
    methods:{
        clearForm(){
            this.editing = false
            this.excuse.Id = null
            this.excuse.EmployeeId = null
            this.excuse.ExcuseTypeId = null
            this.excuse.RequestDate = null
            this.excuse.StartDateTime = null
            this.excuse.EndDateTime = null
            this.excuse.Description = null
            this.excuse.Approved = null
            this.excuse.Document = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        getPersonelExcuse(){
            EmployeeOperationsApi.Excuse.GetDailyCheck(this.date).then(res=>{
                this.personelExcuses = res.data.Data
            })
        },
        getTypes(){
            EmployeeOperationsApi.ExcuseType.List().then(res=>{
                this.types = res.data.Data
            })
        },
        createOrUpdate(){

        }
    },
    computed:{
        currentDay(){
            return moment(this.date,'YYYY-MM-DD').locale('tr').format('LL')
        },
        currentDayName(){
            return moment(this.date,'YYYY-MM-DD').locale('tr').format('dddd')
        }
    }
}
</script>

<style>
.today-icon{
    font-size: 4.5rem;
}
</style>